const CHALLENGE_PREFIX = 'nightshift:ghost-challenge:v1:';
const memoryChallenges = new Map<string, string>();

/** Stores an imported challenge in memory first so strict/private storage
 * policies cannot make a successfully decoded link disappear before race boot. */
export function writeGhostChallengeRecord(mapId: string, raw: string): boolean {
  memoryChallenges.set(mapId, raw);
  try {
    sessionStorage.setItem(`${CHALLENGE_PREFIX}${mapId}`, raw);
    return true;
  } catch {
    return false;
  }
}

export function readGhostChallengeRecord(mapId: string): string | null {
  const memoryChallenge = memoryChallenges.get(mapId);
  if (memoryChallenge !== undefined) return memoryChallenge;
  try {
    return sessionStorage.getItem(`${CHALLENGE_PREFIX}${mapId}`);
  } catch {
    return null;
  }
}

export function clearGhostChallengeRecord(mapId: string): void {
  memoryChallenges.delete(mapId);
  try {
    sessionStorage.removeItem(`${CHALLENGE_PREFIX}${mapId}`);
  } catch {
    // The in-memory copy is authoritative when session storage is blocked.
  }
}
